export default __webpack_public_path__ + "static/media/f_cardlist.bf7719de.svg";